// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '../static/css/commonality.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/common/style.css'
import ElementUI from 'element-ui'
import Axios from 'axios'
import Vue from 'vue'
import App from './App'
import router from './router'
import "babel-polyfill"
import $ from 'jquery'
import '../static/js/jquery-2.0.0.min.js'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import  VueQuillEditor from 'vue-quill-editor'
import echarts from 'echarts'
import '../static/js/md5.js'
import '../static/js/OstPaths.js'
import '../static/js/DataDict.js'
import '../static/js/SubAreas.js'
import '../static/js/DataStore.min.js'
import '../static/js/AreaLinkage.js'
import '../static/js/ajaxFileDownloader.js'
import {getCookie} from '../static/js/cookie.js'
import {formatFn} from '../static/js/date.js'
import {setCookie} from '../static/js/cookie.js'
import { area } from './components/js/area.js'
import * as util from '../src/assets/js/util.js'
import '../src/assets/fonts/iconfont.css'
import store from './store/index.js'


Vue.use(ElementUI);
// Vue.use(VueQuillEditor)
// import * as Quill from 'quill'
// import { ImageDrop } from 'quill-image-drop-module'
// Quill.register('modules/imageDrop', ImageDrop)
// import ImageResize from 'quill-image-resize-module'
// Quill.register('modules/imageResize', ImageResize)
Vue.prototype.Axios = Axios;
// Vue.prototype.geojson = geojson;
Vue.prototype.getCookie = getCookie;
Vue.prototype.setCookie = setCookie;
Vue.prototype.$echars = echarts;
Vue.prototype.area = area;

// Vue.prototype.tdts = tdts;
Vue.prototype.util = util;
Vue.prototype.Axios.defaults.withCredentials = true;
Vue.prototype.Axios.defaults.headers = {
  'Content-Type': 'application/json'
};

// Vue.use(BaiduMap, {
//   ak: 'qvEBjYRcHmpZCDXR849MnC73QGstenOE'
// })
//Vue.use(VueAMap);
// 高德地图
window._AMapSecurityConfig = {
  securityJsCode:'b45032015936e65ac00e672091e043d3',
}
/*
  注意，注意，注意 此项目
    高德地图在个人具体页面引用和初始化，不要在main.js中引用和初始化，避免影响加载api错误。
*/

// VueAMap.initAMapApiLoader({
//   key: 'e3ecea2ee9b0cd018c42744d1567e372',
//   plugin:['AMap.Size','AMap.Pixel', 'AMap.MassMarks ','AMap.MarkerClusterer','AMap.Autocomplete', 'AMap.PlaceSearch',"AMap.DistrictSearch",'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geolocation','AMap.Geocoder', 'AMap.AMapManager', 'AMap.Marker'],
//   // 默认高德 sdk 版本为 1.4.4
//   v: "1.4.15",
//   uiVersion: "1.0"
// });
Vue.prototype.Axios.defaults.xhrFields = {
  withCredentials: true
};
Vue.config.productionTip = false;
/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
console.log(window.location)
router.onError((err) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = err.message.match(pattern);
  if (isChunkLoadFailed) {
    let chunkBool = sessionStorage.getItem('chunkError');
    let nowTimes = Date.now();
    if (chunkBool === null || chunkBool && nowTimes - parseInt(chunkBool) > 60000) {//路由跳转报错,href手动跳转
      sessionStorage.setItem('chunkError', 'reload');
      const targetPath = routers.history.pending.fullPath;
      window.location.href = window.location.origin+'/collect' + targetPath;
    }else if(chunkBool === 'reload'){ //手动跳转后依然报错,强制刷新
      sessionStorage.setItem('chunkError', Date.now());
      window.location.reload(true);
    }
  }
})
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data() {
    return {
      errUrl: '/allorgmsg',
      userType:''
    }
  },
  methods: {
    urljudge:function(){
      
      
      var locationUrl = window.location.pathname;
      if(locationUrl == '/collect/doorIndex'){

      }else{
        if(getCookie('userInfo')) {//添加公用 Authorization
          this.userType = JSON.parse(getCookie('userInfo')).userType
          Axios.defaults.headers.Authorization = JSON.parse(getCookie('userInfo')).tokenType+ ' ' + JSON.parse(getCookie('userInfo')).accessToken
          // console.log(this.userType)
          if(locationUrl =="/login" && this.userType == '20'){
              this.$router.push("/standSpectrumList")
          }
          if(locationUrl =="/login" && this.userType !== '20'){
            this.$router.push("/massSpectaList")
          }
        }else{
          if(locationUrl === "/collect/login1"){
            this.$router.push("/login1")
          }else if(locationUrl === "/collect/nanlogin"){
            this.$router.push("/nanlogin")
          }else if(locationUrl === "/collect/ztLogin"){
            // this.$router.push("/ztLogin")
          }else if(locationUrl === "/collect/topicLibrary"){
            this.$router.push("/topicLibrary")
          }else if(locationUrl === "/collect/dlbzLogin"){
            this.$router.push("/dlbzLogin")
          }else if(locationUrl === "/collect/lsFoodLogin"){
            this.$router.push("/lsFoodLogin")
          }else if(locationUrl === "/collect/emptyCount"){
            // this.$router.push("/emptyCount")
          }else if(locationUrl === "/collect/greenFoodLogin"){
            this.$router.push("/greenFoodLogin")
          }else if(locationUrl === "/collect/directPage"){
            this.$router.push("/directPage")
          } else{
            this.$router.push("/login")
          }
        }
      }
      
    },
    tourl(){
      var locationUrl = window.location.pathname;
    },
  },
  watch:{
    '$route':function(val,nval){
      console.log(val,nval,"val,nval")
      var locationUrl = window.location.pathname;
      
      // this.urljudge();  
       Axios.interceptors.response.use(function(res){
        //在这里对返回的数据进行处理
        console.log(res,"watchres")
        var data = res.data;
        return res;
      },function(err){
        console.log(err,'err')
        //Do something with response error
        var isErrInfo = arguments[0].response.data.error_description.indexOf('Access token expired');//权限是否过期
        if(isErrInfo>=0) {
          setCookie('userInfo','');
          if(val.meta.isLogin){
            this.$router.push(val.meta.path)
          }
          // console.log(locationUrl,"locationUrl")
          // if(val.meta.isLogin && locationUrl=== "/collect/login1"){
          //   this.$router.push("/login1")
          // }else if(locationUrl === "/collect/ztLogin"){
          //   // this.$router.push("/ztLogin")
          // }else if(locationUrl === "/collect/topicLibrary"){
          //   this.$router.push("/topicLibrary")
          // }else if(locationUrl === "/collect/dlbzLogin"){
          //   this.$router.push("/dlbzLogin")
          // }else if(locationUrl === "/collect/lsFoodLogin"){
          //   this.$router.push("/lsFoodLogin")
          // }else if(locationUrl === "/collect/nanlogin"){
          //   this.$router.push("/nanlogin")
          // }else{
          //   this.$router.push("/login")
          // }
        }
        return Promise.reject(err);
      });
    return false;
    }
  },
  mounted() {
    this.urljudge();
  }
})



// WEBPACK FOOTER //
// ./src/main.js